import { GUIDHelper } from "./guidHelper";

export class User {
    private static readonly STORAGE_KEY: string = 'vis_user';

    public static getUserId() {
        let userId: string = JSON.parse(localStorage.getItem(this.STORAGE_KEY));

        if (!userId) {
            userId = GUIDHelper.create();
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(userId));
        }

        return userId;
    }
}